import NamespacesContainer from './namespaces_container.js'

export default Vue.extend({
  components: {
    'namespaces-container': NamespacesContainer
  },

  props: {
    initialNamespaces: {
      type: Array,
      default() {
        return []
      }
    }
  },

  data() {
    return {
      namespaces: this.initialNamespaces
    }
  },

  template: `
    <namespaces-container title="所有空间">
      <template slot="actions">
        <button class="btn btn-primary btn-small" @click="goToNew">
          <i class="slp-plus"></i>
          新建空间
        </button>
      </template>
      <template slot="content">
        <div class="namespaces-table-wrapper">
          <table class="table table-noborder table-striped namespaces-table">
            <thead>
              <tr>
                <th>名字</th>
                <th>空间后缀名</th>
                <th>APPID</th>
                <th class="num-col">组织数</th>
                <th class="num-col">人员数</th>
                <th class="num-col">绑定数</th>
                <th class="operation-col">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="namespaces.length === 0">
                <td colspan="7" class="text-center text-muted">暂无空间</td>
              </tr>
              <tr v-for="namespace in namespaces"
                  :key="namespace.id"
                  class="table-row">
                <td>
                  <a :href="namespace.urls.show" class="row-link text-ellipsis">{{ namespace.name }}</a>
                </td>
                <td class="text-ellipsis">{{ namespace.site_name }}</td>
                <td class="text-ellipsis">{{ namespace.appid }}</td>
                <td class="num-col">{{ namespace.organizations_count }}</td>
                <td class="num-col">{{ namespace.users_count }}</td>
                <td class="num-col">{{ namespace.binded_users_count }}</td>
                <td class="operation-col">
                  <a :href="namespace.urls.show" class="btn-text primary-text mr-3">查看</a>
                  <a :href="namespace.urls.edit" class="btn-text primary-text">编辑</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
    </namespaces-container>
  `,

  methods: {
    goToNew() {
      Turbolinks.visit('/admin/namespaces/new')
    }
  }
})
